export const GET_COUPON_URL = "GET_COUPON_URL";
export const GET_COUPON_URL_SUCCESS = "GET_COUPON_URL_SUCCESS";
export const GET_COUPON_URL_FAILURE = "GET_COUPON_URL_FAILURE";
export const SET_COUPON_URL_LOADING = "SET_COUPON_URL_LOADING";
export const RESET_COUPON_URL = "RESET_COUPON_URL";
